import axios from '@/utils/request-manage'

export const getDefaultDoc = (data = {}) => {
  return axios.get('/document/default', data)
}

export const saveDocument = (data) => {
  return axios.post(data.Id ? '/document/update' : '/document/add', data)
}

export const getDoc = (id = '') => {
  return axios.post('/document/get', { id: id })
}

export const getChildren = (id = '') => {
  return axios.post('/document/children', { id: id })
}

export const getRecycled = (data = {}) => {
  return axios.post('/document/recycled', data)
}

export const deleteDocument = (data) => {
  return axios.post('/document/delete', data)
}
